import { useContext } from 'react';

import { useNavigate } from 'react-router-dom';

import { DebtConContext } from '@src/app/contexts/DebtCon';
import { LinkButton } from '@src/ui/components/LinkButton';

import ArrowCircleLeftIcon from '../Icons/ArrowCircleLeftIcon';
import ChevronBack from '../Icons/ChevronBack';

const BackButton = () => {
    const { currentDebtIndex, setCurrentDebtIndex, reviewPageNav } =
        useContext(DebtConContext);
    const navigate = useNavigate();
    const currentPath = window.location.pathname;

    const handleNavigate = () => {
        const navigationMap: Record<string, () => void> = {
            '/eligibility/applicants': () => navigate('/eligibility'),
            '/eligibility/debt-con/intro': () =>
                navigate('/eligibility/outgoings'),
            '/eligibility/debt-con/transition': () =>
                navigate('/eligibility/debt-con/borrow'),
            '/eligibility/debt-con/new-input': () =>
                navigate('/eligibility/debt-con/review'),
            '/eligibility/debt-con/input': () => {
                if (reviewPageNav) {
                    navigate('/eligibility/debt-con/review');
                } else if (currentDebtIndex === 0) {
                    navigate('/eligibility/debt-con/transition');
                } else {
                    setCurrentDebtIndex(currentDebtIndex - 1);
                }
            },
            '/eligibility/debt-con/review': () => {
                navigate('/eligibility/debt-con/input');
            },
            '/eligibility/loan-preferences/questions': () =>
                navigate('/eligibility/loan-preferences/homepage'),
            '/eligibility/loan-preferences/book-call': () =>
                navigate('/eligibility/loan-preferences/questions'),
            '/eligibility/loan-preferences/book-call/confirmation': () =>
                navigate('/eligibility/loan-preferences/book-call/calendar'),
            '/eligibility/loan-preferences/book-call/calendar': () =>
                navigate('/eligibility/loan-preferences/book-call'),
        };

        (navigationMap[currentPath] || (() => navigate(-1)))();
    };

    const isMobilePathForOfferAndDebtCon =
        (currentPath.includes('/eligibility/loan-details') ||
            currentPath.includes('/eligibility/applicants') ||
            currentPath.includes('/eligibility/property-details') ||
            currentPath.includes('/eligibility/income') ||
            currentPath.includes('/eligibility/outgoings') ||
            currentPath.includes('offer/finalise') ||
            currentPath.includes('offer/book-call') ||
            currentPath.includes('debt-con/intro') ||
            currentPath.includes('debt-con/main-goal') ||
            currentPath.includes('debt-con/borrow') ||
            currentPath.includes('debt-con/transition') ||
            currentPath.includes('debt-con/input') ||
            currentPath.includes('debt-con/new-input') ||
            currentPath.includes('debt-con/review') ||
            currentPath.includes('loan-preferences/homepage') ||
            currentPath.includes('loan-preferences/questions') ||
            currentPath.includes('loan-preferences/book-call') ||
            currentPath.includes('loan-preferences/book-call/confirmation') ||
            currentPath.includes('loan-preferences/book-call/calendar')) &&
        window.innerWidth < 1024;

    return (
        <div
            className='flex items-center cursor-pointer'
            onClick={handleNavigate}
        >
            {isMobilePathForOfferAndDebtCon ? (
                <LinkButton
                    noHoverChange={true}
                    className='pr-4 lg:w-48 text-steel-60'
                >
                    <ChevronBack />
                </LinkButton>
            ) : (
                <>
                    <ArrowCircleLeftIcon />
                    <LinkButton
                        noHoverChange={true}
                        className='pr-4 w-0 lg:w-48 font-sora-bold text-midnight-200 ml-0.5'
                    >
                        Back
                    </LinkButton>
                </>
            )}
        </div>
    );
};

export default BackButton;
